import { render, staticRenderFns } from "./ParticipantLawyer.vue?vue&type=template&id=de0d9d7a"
import script from "./ParticipantLawyer.vue?vue&type=script&lang=js"
export * from "./ParticipantLawyer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports